// extracted by mini-css-extract-plugin
export var container = "styles-module--container--jqnpZ";
export var nav = "styles-module--nav--cz8dI";
export var socials = "styles-module--socials--dDsGt";